import Accordion from '../UI/Accordion/Accordion';
import Container from '../UI/Container/Container';
import Title from '../UI/Title/Title';
import styles from './FAQ.module.scss';

function FAQ() {
  return (
    <section className={styles.faq}>
      <Container>
        <Title className={styles.title} variant="h2">Вопрос/Ответ</Title>
        <div className={styles.wrapper}>
          <Accordion
            title="Может ли ребёнок заниматься самостоятельно?"
            text="Оплатить могут только авторизованные пользователи. Оплата совершается с помощью сервиса SberPay. Данный сервис позволит быстро и безопасно оплатить заявку."
          />
          <Accordion
            title="Как происходит оплата?"
            text="Оплатить могут только авторизованные пользователи. Оплата совершается с помощью сервиса SberPay. Данный сервис позволит быстро и безопасно оплатить заявку."
          />
          <Accordion
            title="Есть ли гарантии усвоения материала?"
            text="Оплатить могут только авторизованные пользователи. Оплата совершается с помощью сервиса SberPay. Данный сервис позволит быстро и безопасно оплатить заявку."
          />
          <Accordion
            title="С кем будет общаться мой ребёнок?"
            text="Оплатить могут только авторизованные пользователи. Оплата совершается с помощью сервиса SberPay. Данный сервис позволит быстро и безопасно оплатить заявку."
          />
          <Accordion
            title="Каковы принципы обучения?"
            text="Оплатить могут только авторизованные пользователи. Оплата совершается с помощью сервиса SberPay. Данный сервис позволит быстро и безопасно оплатить заявку."
          />
          <Accordion
            title="Сколько раз в неделю можно заниматься?"
            text="Оплатить могут только авторизованные пользователи. Оплата совершается с помощью сервиса SberPay. Данный сервис позволит быстро и безопасно оплатить заявку."
          />
        </div>
      </Container>
    </section>
  );
}

export default FAQ;
